module.exports = __webpack_public_path__ + "static/img/about.da568eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero/about.jpg
// module id = /Uqg
// module chunks = 1